export const couponBoxCustomJsTemplate =
`/* Add custom script to Proof Factor Wheel Events listeners below */

// window.addEventListener('prooffactor:couponbox:open', (e) => {
//     console.log('prooffactor:couponbox:open', {
//         id: e.detail.id
//     });
// });

// window.addEventListener('prooffactor:couponbox:close', (e) => {
//     console.log('prooffactor:couponbox:close', {
//         id: e.detail.id,
//         email: e.email,
//         phone: e.formattedPhoneNumber,
//         first_name: e.firstName,
//         last_name: e.lastName,
//         birthday: e.birthday,
//         optin: this.optin
//     });
// });

// window.addEventListener('prooffactor:couponbox:submit', (e) => {
//     console.log('prooffactor:couponbox:submit', {
//         id: e.detail.id,
//         email: e.email,
//         phone: e.formattedPhoneNumber,
//         first_name: e.firstName,
//         last_name: e.lastName,
//         birthday: e.birthday,
//         optin: this.optin
//     });
// });

// window.addEventListener('prooffactor:couponbox:copy', (e) => {
//     console.log('prooffactor:couponbox:copy', {
//         id: e.detail.id,
//         email: e.email,
//         phone: e.formattedPhoneNumber,
//         first_name: e.firstName,
//         last_name: e.lastName,
//         birthday: e.birthday,
//         optin: this.optin
//     });
// });
`
